export enum PermissionKey {
  CAN_ACCESS_ACCOUNTING = 'can_access_accounting',
  CAN_ADD_ADVISOR_QUESTIONS = 'can_add_advisor_questions',
  CAN_ACCESS_ADMIN_ROUTES = 'can_access_admin_routes',
  CAN_ACCESS_ADVISOR_ADMIN_ANALYTICS = 'can_access_advisor_admin_analytics',
  CAN_ACCESS_ADVISOR_BOOKING_LINK = 'can_access_advisor_booking_link',
  CAN_ACCESS_ADVISOR_CLIENT_JOURNEY = 'can_access_advisor_client_journey',
  CAN_ACCESS_ADVISOR_DOCUMENTS_TAB = 'can_access_advisor_documents_tab',
  CAN_ACCESS_ADVISOR_FAMILY_TREE = 'can_access_advisor_family_tree',
  CAN_ACCESS_ADVISOR_PRO = 'can_access_advisor_pro',
  CAN_ACCESS_AFTERCARE_CONSULTATION = 'can_access_aftercare_consultation',
  CAN_ACCESS_AI_RESEARCH = 'can_access_ai_research',
  CAN_ACCESS_ALL_CONVERSATIONS = 'can_access_all_conversations',
  CAN_ACCESS_ALL_TIME_ENTRIES = 'can_access_all_time_entries',
  CAN_ACCESS_ALTERNATE_LIQUIDATION_PATH = 'can_access_alternate_liquidation_path',
  CAN_ACCESS_ANNUAL_REVIEW = 'can_access_annual_review',
  CAN_ACCESS_ANNUAL_REVIEW_V2 = 'can_access_annual_review_v2',
  CAN_ACCESS_BANK_STATEMENT_PARSER = 'can_access_bank_statement_parser',
  CAN_ACCESS_BILLING = 'can_access_billing',
  CAN_ACCESS_BILLING_SANDBOX = 'can_access_billing_sandbox',
  CAN_ACCESS_CASHFLOWS_V2 = 'can_access_cashflows_v2',
  CAN_ACCESS_CLARA_CONTENT_LIBRARY = 'can_access_clara_content_library',
  CAN_ACCESS_CLARA_FOR_ADVISORS = 'can_access_clara_for_advisors',
  CAN_ACCESS_CLARA_FOR_PLANNERS = 'can_access_clara_for_planners',
  CAN_ACCESS_CLARA_INBOX_DRAFTS = 'can_access_clara_inbox_drafts',
  CAN_ACCESS_CLAUSE_LIBRARY = 'can_access_clause_library',
  CAN_ACCESS_CLEAR_ESTATE_FILE_MANAGEMENT_PAGE = 'can_access_clear_estate_file_management_page',
  CAN_ACCESS_CLEAR_WILL_BILLING = 'can_access_clear_will_billing',
  CAN_ACCESS_CLEAR_WILL_DASHBOARD_PAGE = 'can_access_clear_will_dashboard_page',
  CAN_ACCESS_CLEAR_WILL_ESTATE_ACCOUNTING_PAGE = 'can_access_clear_will_estate_accounting_page',
  CAN_ACCESS_CLEAR_WILL_FILE_MANAGEMENT_PAGE = 'can_access_clear_will_file_management_page',
  CAN_ACCESS_DEFINE_YOUR_SITUATION_STAGE = 'can_access_define_your_situation_stage',
  CAN_ACCESS_SELF_SERVE_FLOW = 'can_access_self_serve_flow',
  CAN_ACCESS_STANDARD_PLAN_GUIDANCE_STEPS = 'can_access_standard_plan_guidance_steps',
  CAN_ACCESS_STANDARD_PLAN_WILL_REVIEW_MEETING = 'can_access_standard_plan_will_review_meeting',
  CAN_ACCESS_CLEAR_WILL_INBOX_PAGE = 'can_access_clear_will_inbox_page',
  CAN_ACCESS_CLEAR_WILL_IN_OVERVIEW = 'can_access_clear_will_in_overview',
  CAN_ACCESS_CLEAR_WILL_POAS = 'can_access_clear_will_poas',
  CAN_ACCESS_CONQUEST_EXTRACTION = 'can_access_conquest_extraction',
  CAN_ACCESS_CONTACTS_PAGE = 'can_access_contacts_page',
  CAN_ACCESS_COUPLES_SPACE_CLEARDESK = 'can_access_couples_space_cleardesk',
  CAN_ACCESS_DETECT_AUTH_SESSION_MISMATCH = 'can_access_detect_auth_session_mismatch',
  CAN_ACCESS_DEMO_DATA = 'can_access_demo_data',
  CAN_VIEW_DISTRIBUTION_NO_LONGER_AVAILABLE = 'can_view_distribution_no_longer_available',
  CAN_ACCESS_DOCUMENT_BUILDER = 'can_access_document_builder',
  CAN_ACCESS_DOCUMENTS = 'can_access_documents',
  CAN_ACCESS_REFER_QUEBEC_WITNESSED_WILL_PLANS = 'can_access_refer_quebec_witnessed_will_plans',
  CAN_ACCESS_DOCU_SIGN = 'can_access_docu_sign',
  CAN_ACCESS_EMAIL_CHANGE = 'can_access_email_change',
  CAN_ACCESS_EMAIL_OTP = 'can_access_email_otp',
  CAN_ACCESS_ESTATE_DEMO_TEMPLATE_CREATION = 'can_access_estate_demo_template_creation',
  CAN_ACCESS_ESTATE_DIAGNOSTIC_TOOL = 'can_access_estate_diagnostic_tool',
  CAN_ACCESS_ESTATE_DISTRIBUTION = 'can_access_estate_distribution',
  CAN_ACCESS_ESTATE_RAG = 'can_access_estate_rag',
  CAN_ACCESS_ESTATE_SETTINGS = 'can_access_estate_settings',
  CAN_ACCESS_FAMILY_TREE = 'can_access_family_tree',
  CAN_ACCESS_FAMILY_PATRIMONY_LEARN_MORE_SCREEN = 'can_access_family_patrimony_learn_more_screen',
  CAN_ACCESS_FINAL_ESTATE_REPORT_IN_CLEAR_DESK = 'can_access_final_estate_report_in_clear_desk',
  CAN_ACCESS_FINAL_TAXES_CALCULATOR_TOOL = 'can_access_final_taxes_calculator_tool',
  CAN_ACCESS_FIRST_NATIONS_DISCLAIMERS = 'can_access_first_nations_disclaimers',
  CAN_ACCESS_FLINKS = 'can_access_flinks',
  CAN_ACCESS_FLINKS_INVESTMENT = 'can_access_flinks_investment',
  CAN_ACCESS_FLINKS_SANDBOX = 'can_access_flinks_sandbox',
  CAN_ACCESS_FUNERAL_ARRANGEMENT_STAGE_V2 = 'can_access_funeral_arrangement_stage_v2',
  CAN_ACCESS_GENERATED_DOCUMENTS = 'can_access_generated_documents',
  CAN_ACCESS_GUIDANCE_STEPS = 'can_access_guidance_steps',
  CAN_ACCESS_GUIDES = 'can_access_guides',
  CAN_ACCESS_HEADLESS_CALENDLY_BOOKING = 'can_access_headless_calendly_booking',
  CAN_ACCESS_HELP_CENTER = 'can_access_help_center',
  CAN_ACCESS_INBOX = 'can_access_inbox',
  CAN_ACCESS_INBOX_V2 = 'can_access_inbox_v2',
  CAN_ACCESS_INBOX_IMPERSONATION = 'can_access_inbox_impersonation',
  CAN_ACCESS_INBOX_IN_OVERVIEW = 'can_access_inbox_in_overview',
  CAN_ACCESS_INBOX_VIDEO = 'can_access_inbox_video',
  CAN_ACCESS_ESTATE_CLARA = 'can_access_estate_clara',
  CAN_ACCESS_LEGACY_LETTERS = 'can_access_legacy_letters',
  CAN_ACCESS_LIDAAP_ONBOARDING = 'can_access_lidaap_onboarding',
  CAN_ACCESS_LIDAAP_STANDALONE = 'can_access_lidaap_standalone',
  CAN_ACCESS_MEETINGS = 'can_access_meetings',
  CAN_ACCESS_MEMBERS_PAGE = 'can_access_members_page',
  CAN_ACCESS_MOBILE_DOCUMENT_SCAN = 'can_access_mobile_document_scan',
  CAN_ACCESS_NEEDS_NOTIFY_CREDITORS_UPSELL = 'can_access_needs_notify_creditors_upsell',
  CAN_ACCESS_NEEDS_WILL_SEARCH_UPSELL = 'can_access_needs_will_search_upsell',
  CAN_ACCESS_NEW_ADVISOR_PRO_UPSELL_MODAL = 'can_access_new_advisor_pro_upsell_modal',
  CAN_ACCESS_NEW_EDITOR_WILL_REVIEW_STEPS_FLOW = 'can_access_new_editor_will_review_steps_flow',
  CAN_ACCESS_NEW_POAS = 'can_access_new_poas',
  CAN_ACCESS_NEW_PRIMARY_WILL = 'can_access_new_primary_will',
  CAN_ACCESS_NEW_SECONDARY_WILL = 'can_access_new_secondary_will',
  CAN_ACCESS_SELF_SERVE_EDITOR_WILL = 'can_access_self_serve_editor_will',
  CAN_ACCESS_NEXT_STEP_WIDGET = 'can_access_next_step_widget',
  CAN_ACCESS_NLP_PARSE_DRIVERS_LICENSE = 'can_access_nlp_parse_drivers_license',
  CAN_ACCESS_NOTIFICATION_CENTER = 'can_access_notification_center',
  CAN_ACCESS_NOVA = 'can_access_nova',
  CAN_ACCESS_OTP = 'can_access_otp',
  CAN_ACCESS_PARTNERS = 'can_access_partners',
  CAN_ACCESS_PERMISSION_SETS = 'can_access_permission_sets',
  CAN_ACCESS_PET_STEP = 'can_access_pet_step',
  CAN_ACCESS_PLAID = 'can_access_plaid',
  CAN_ACCESS_PLAID_SANDBOX = 'can_access_plaid_sandbox',
  CAN_ACCESS_PLANNING_ONBOARDING_REDESIGN = 'can_access_planning_onboarding_redesign',
  CAN_ACCESS_POA_EXTRACTION = 'can_access_poa_extraction',
  CAN_ACCESS_POA_INSTRUCTION_IMPROVEMENTS = 'can_access_poa_instruction_improvements',
  CAN_ACCESS_POST_ONBOARDING_INTAKE_MEETING_FLOW = 'can_access_post_onboarding_intake_meeting_flow',
  /**
   * @deprecated the protection mandate product key is deprecated and included in self-serve plans in QC
   */
  CAN_ACCESS_PROTECTION_MANDATE = 'can_access_protection_mandate',
  CAN_ACCESS_PROFESSIONAL_EXECUTOR_UPSELL = 'can_access_professional_executor_upsell',
  CAN_ACCESS_TEAMS_SESSION = 'can_access_teams_session',
  CAN_ACCESS_QUEBEC_DISTRIBUTION = 'can_access_quebec_distribution',
  CAN_ACCESS_RESOURCES = 'can_access_resources',
  CAN_ACCESS_SMS_OTP = 'can_access_sms_otp',
  CAN_ACCESS_SOLUTION_PICKER = 'can_access_solution_picker',
  CAN_ACCESS_SPOTLIGHT_SEARCH = 'can_access_spotlight_search',
  CAN_ACCESS_STANDARD_PLAN = 'can_access_standard_plan',
  CAN_ACCESS_STEP_447431 = 'can_access_step447431',
  CAN_ACCESS_TAXES = 'can_access_taxes',
  CAN_ACCESS_TEAMS = 'can_access_teams',
  CAN_ACCESS_TEAM_WORKLOAD = 'can_access_team_workload',
  CAN_ACCESS_TEMPLATES = 'can_access_templates',
  CAN_ACCESS_TIME_SAVINGS_WIDGET = 'can_access_time_savings_widget',
  CAN_ACCESS_TRANSLATIONS = 'can_access_translations',
  CAN_ACCESS_TRIAGE = 'can_access_triage',
  CAN_ACCESS_UPDATED_REFERRALS_TABLE_UI = 'can_access_updated_referrals_table_ui',
  CAN_ACCESS_USERS = 'can_access_users',
  CAN_ACCESS_USER_ASSIGNMENT = 'can_access_user_assignment',
  CAN_ACCESS_USER_LINKING = 'can_access_user_linking',
  CAN_ACCESS_US_FINALIZE_INVENTORY_VALUE_STAGE = 'can_access_us_finalize_inventory_value_stage',
  CAN_ACCESS_WELCOME_FLOW = 'can_access_welcome_flow',
  CAN_ACCESS_WILL_REVIEW_ACKNOWLEDGMENT = 'can_access_will_review_acknowledgment',
  CAN_ACCESS_WILL_REVIEW_MEETING = 'can_access_will_review_meeting',
  CAN_ACCESS_WORKFLOWS = 'can_access_workflows',
  CAN_ACCESS_IN_APP_ANNOUNCEMENTS = 'can_access_in_app_announcements',
  CAN_ARCHIVE_INBOX_CONVERSATIONS = 'can_archive_inbox_conversations',
  CAN_ASSIGN_CONSULTANT = 'can_assign_consultant',
  CAN_ASSIGN_CONSULTANT_ADMIN = 'can_assign_consultant_admin',
  CAN_ASSIGN_ESTATE_BANKING_REQUEST_CASE_MANAGER = 'can_assign_estate_banking_request_case_manager',
  CAN_ASSIGN_ESTATE_PROFESSIONAL = 'can_assign_estate_professional',
  CAN_ASSIGN_ESTATE_TASK_TO_TEAM = 'can_assign_estate_task_to_team',
  CAN_ASSIGN_JUNIOR_ESTATE_PROFESSIONAL = 'can_assign_junior_estate_professional',
  CAN_ASSIGN_PROFESSIONAL_EXECUTOR = 'can_assign_professional_executor',
  CAN_ASSIGN_USERS = 'can_assign_users',
  CAN_ASSIGN_TRUST_OFFICER = 'can_assign_trust_officer',
  CAN_AUTO_PLAY_GUIDES = 'can_auto_play_guides',
  CAN_AUTO_REFRESH_FLINKS_BALANCE = 'can_auto_refresh_flinks_balance',
  CAN_CHANGE_ESTATE = 'can_change_estate',
  CAN_CLOSE_ESTATE = 'can_close_estate',
  CAN_CONNECT_USER_TO_OUTLOOK = 'can_connect_user_to_outlook',
  CAN_CREATE_COMPENSATION_LIABILITY = 'can_create_compensation_liability',
  CAN_CREATE_CONVERSATIONS = 'can_create_conversations',
  CAN_CREATE_CUSTOM_PARALEGAL = 'can_create_custom_paralegal',
  CAN_CREATE_ESTATE = 'can_create_estate',
  CAN_CREATE_ESTATE_FROM_HUB_SPOT = 'can_create_estate_from_hub_spot',
  CAN_CREATE_ESTIMATED_FINAL_TAXES = 'can_create_estimated_final_taxes',
  CAN_CREATE_TEAMS = 'can_create_teams',
  CAN_CREATE_VAULT = 'can_create_vault',
  CAN_CREATE_WILL = 'can_create_will',
  CAN_DELETE_DOCUMENT = 'can_delete_document',
  CAN_DELETE_ESTATE = 'can_delete_estate',
  CAN_DELETE_USER = 'can_delete_user',
  CAN_DISPLAY_PRIMARY_ESTATE_PROFESSIONAL_PHONE_NUMBER_ON_DASHBOARD_PAGE = 'can_display_primary_estate_professional_phone_number_on_dashboard_page',
  CAN_EXPORT_ACCOUNTING_REPORT = 'can_export_accounting_report',
  CAN_EXPORT_NEW_ACCOUNTING_REPORT = 'can_export_new_accounting_report',
  CAN_EXPORT_CLEAR_ESTATE_SUMMARY = 'can_export_clear_estate_summary',
  CAN_EXPORT_CLEAR_VAULT_SUMMARY = 'can_export_clear_vault_summary',
  CAN_FORCE_SHOW_CANADIAN_ESTATE_BANKING_ACCOUNT = 'can_force_show_canadian_estate_banking_account',
  CAN_GENERATE_ESTATE_AI_SUMMARY = 'can_generate_estate_ai_summary',
  CAN_GENERATE_ESTATE_SNAPSHOT = 'can_generate_estate_snapshot',
  CAN_HIDE_COMPLETE_CONTACT_INFO = 'can_hide_complete_contact_info',
  CAN_ACCESS_MICRO_TIP = 'can_access_micro_tip',
  CAN_IMPERSONATE_USER = 'can_impersonate_user',
  CAN_INVITE_BENEFICIARY = 'can_invite_beneficiary',
  CAN_INVITE_CONTACTS = 'can_invite_contacts',
  CAN_INVITE_EXECUTOR = 'can_invite_executor',
  CAN_INVITE_MEMBERS = 'can_invite_members',
  CAN_INVITE_PROFESSIONAL = 'can_invite_professional',
  CAN_LOG_ISSUE = 'can_log_issue',
  CAN_LOG_TIME = 'can_log_time',
  CAN_MANAGE_COMPANY = 'can_manage_company',
  CAN_MANAGE_ESTATE = 'can_manage_estate',
  CAN_MANAGE_ESTATE_BANKING_REQUEST = 'can_manage_estate_banking_request',
  CAN_MANAGE_ESTATE_PROFESSIONALS = 'can_manage_estate_professionals',
  CAN_PAY_STANDARD_PLAN_RECURRING_FEE = 'can_pay_standard_plan_recurring_fee',
  CAN_ACCESS_REFERRAL_VAULT_PRE_FILLING = 'can_access_referral_vault_pre_filling',
  CAN_READ_ASSET = 'can_read_asset',
  CAN_READ_CASHFLOWS = 'can_read_cashflows',
  CAN_READ_CONNECTION = 'can_read_connection',
  CAN_READ_CONTACT = 'can_read_contact',
  CAN_READ_DOCUMENT = 'can_read_document',
  CAN_READ_ESTATE_DISTRIBUTION = 'can_read_estate_distribution',
  CAN_REQUIRE_OTP = 'can_require_otp',
  CAN_VIEW_ESTATE_TAX_FORM = 'can_view_estate_tax_form',
  CAN_READ_INVENTORY = 'can_read_inventory',
  CAN_READ_LIABILITY = 'can_read_liability',
  CAN_READ_MEMBER = 'can_read_member',
  CAN_READ_PARTNER_USER = 'can_read_partner_user',
  CAN_READ_PERMISSION_SETS = 'can_read_permission_sets',
  CAN_READ_PROFESSIONAL = 'can_read_professional',
  CAN_READ_TAX = 'can_read_tax',
  CAN_READ_TEAM = 'can_read_team',
  CAN_READ_USER = 'can_read_user',
  CAN_READ_WORKFLOWS = 'can_read_workflows',
  CAN_REGENERATE_WILL = 'can_regenerate_will',
  CAN_REGISTER_FOR_MEMOIR = 'can_register_for_memoir',
  CAN_SEND_DOCUMENT_MAGIC_LINKS = 'can_send_document_magic_links',
  CAN_SEND_STEP_REMINDER_MESSAGE = 'can_send_step_reminder_message',
  CAN_SHARE_DOCUMENTS_IN_INBOX = 'can_share_documents_in_inbox',
  CAN_SHOW_UNSAVED_CHANGES_WARNING_MODAL = 'can_show_unsaved_changes_warning_modal',
  CAN_TOGGLE_DEVELOPER_MODE = 'can_toggle_developer_mode',
  CAN_TOGGLE_LANGUAGE = 'can_toggle_language',
  CAN_TRANSITION_CLEAR_VAULT_TO_CLEAR_WILL_ON_OVERVIEW = 'can_transition_clear_vault_to_clear_will_on_overview',
  CAN_USE_CONTACT_ALIASES_IN_GENERATED_DOCUMENTS = 'can_use_contact_aliases_in_generated_documents',
  CAN_USE_CONTACT_SELECTOR_IN_STEPS = 'can_use_contact_selector_in_steps',
  CAN_USE_DOC_INGESTION = 'can_use_doc_ingestion',
  CAN_USE_DOCUMENT_AI = 'can_use_document_ai',
  CAN_USE_EDITOR_AUTOSAVE = 'can_use_editor_autosave',
  CAN_USE_MANITOBA_POA_PROPERTY_HOMESTEAD = 'can_use_manitoba_poa_property_homestead',
  CAN_USE_SUBMODULE_STEP_UI = 'can_use_submodule_step_ui',
  CAN_VIEW_ADVISOR_PRO_UPSELLS = 'can_view_advisor_pro_upsells',
  CAN_VIEW_ALL_ESTATE_BANKING_REQUEST_DETAILS = 'can_view_all_estate_banking_request_details',
  CAN_VIEW_AUTOMATED_QA_SELF_SERVE_BANNER = 'can_view_automated_qa_self_serve_banner',
  CAN_VIEW_BENEFICIARY_WIDGET = 'can_view_beneficiary_widget',
  CAN_VIEW_BILLING_PLAN = 'can_view_billing_plan',
  CAN_VIEW_CLEAR_DESK = 'can_view_clear_desk',
  CAN_VIEW_CLARA_MAINTENANCE_PAGE = 'can_view_clara_maintenance_page',
  CAN_VIEW_CLEAR_VAULT_INTAKE_QUESTION_STEP = 'can_view_clear_vault_intake_question_step',
  CAN_VIEW_CLEAR_WILL_FINAL_VIDEO = 'can_view_clear_will_final_video',
  CAN_VIEW_COLLABORATORS_FOLDER = 'can_view_collaborators_folder',
  CAN_VIEW_COMPANY_ANNOUNCEMENT = 'can_view_company_announcement',
  CAN_VIEW_CONTACTS_TOUR_GUIDE = 'can_view_contacts_tour_guide',
  CAN_VIEW_DISABLE_VPN_BANNER = 'can_view_disable_vpn_banner',
  CAN_VIEW_DOCUMENT_BUILDER_TOUR_GUIDE = 'can_view_document_builder_tour_guide',
  CAN_VIEW_DOCUMENTS_TOUR_GUIDE = 'can_view_documents_tour_guide',
  CAN_VIEW_ESIGN_RECIPIENTS_AND_ENVELOPE_STATUS = 'can_view_esign_recipients_and_envelope_status',
  CAN_VIEW_ESTATE_PLAN_MEMO = 'can_view_estate_plan_memo',
  CAN_VIEW_EXECUTOR_ADDENDUM = 'can_view_executor_addendum',
  CAN_VIEW_EXECUTOR_CENTRE = 'can_view_executor_centre',
  CAN_VIEW_FINANCIALS_TOUR_GUIDE = 'can_view_financials_tour_guide',
  CAN_VIEW_IG_TAX_TAB = 'can_view_ig_tax_tab',
  CAN_VIEW_INBOX_MEMBERS_LIST = 'can_view_inbox_members_list',
  CAN_VIEW_INBOX_RENAME_CHAT = 'can_view_inbox_rename_chat',
  CAN_VIEW_INBOX_VIDEO = 'can_view_inbox_video',
  CAN_VIEW_INBOX_VIEW_FILES = 'can_view_inbox_view_files',
  CAN_VIEW_MARKETPLACE = 'can_view_marketplace',
  CAN_VIEW_NEW_FINANCIAL_ADVISOR_DASHBOARD = 'can_view_new_financial_advisor_dashboard',
  CAN_VIEW_NEW_LAWYER_NOTARY_ASSIGNMENT = 'can_view_new_lawyer_notary_assignment',
  CAN_VIEW_MEETINGS_TOUR_GUIDE = 'can_view_meetings_tour_guide',
  CAN_VIEW_MEMBERS_WIDGET = 'can_view_members_widget',
  CAN_VIEW_PLANNING_ASSET_LIABILITY_UPDATES = 'can_view_planning_asset_liability_updates',
  CAN_VIEW_POA_PERSONAL_CARE_MAINTENANCE_WIDGET = 'can_view_poa_personal_care_maintenance_widget',
  CAN_VIEW_POA_PROPERTY_MAINTENANCE_WIDGET = 'can_view_poa_property_maintenance_widget',
  CAN_VIEW_QA_SELF_SERVE_BANNER = 'can_view_qa_self_serve_banner',
  CAN_VIEW_REAL_ESTATE_TITLE_SEARCH_UPSELL = 'can_view_real_estate_title_search_upsell',
  CAN_VIEW_ROLE_CONFLICT_WARNING = 'can_view_role_conflict_warning',
  CAN_VIEW_SPECIFIC_ESTATE = 'can_view_specific_estate',
  CAN_VIEW_UNASSIGNED_ESTATES = 'can_view_unassigned_estates',
  CAN_VIEW_USER_LOGIN_INFO = 'can_view_user_login_info',
  CAN_WRITE_ASSET = 'can_write_asset',
  CAN_WRITE_BENEFICIARY_IN_DISTRIBUTION = 'can_write_beneficiary_in_distribution',
  CAN_WRITE_CASHFLOWS = 'can_write_cashflows',
  CAN_WRITE_COMPANY = 'can_write_company',
  CAN_WRITE_CONNECTION = 'can_write_connection',
  CAN_WRITE_CONTACT = 'can_write_contact',
  CAN_WRITE_DOCUMENT = 'can_write_document',
  CAN_WRITE_ESTATE_DISTRIBUTION = 'can_write_estate_distribution',
  CAN_WRITE_ESTATE_TAX_FORM = 'can_write_estate_tax_form',
  CAN_WRITE_INVENTORY = 'can_write_inventory',
  CAN_WRITE_LIABILITY = 'can_write_liability',
  CAN_WRITE_MEMBER = 'can_write_member',
  CAN_WRITE_NOTE = 'can_write_note',
  CAN_WRITE_PARTNER_USER = 'can_write_partner_user',
  CAN_WRITE_PERMISSION_SETS = 'can_write_permission_sets',
  CAN_WRITE_PROFESSIONAL = 'can_write_professional',
  CAN_WRITE_TAX = 'can_write_tax',
  CAN_WRITE_TEAM = 'can_write_team',
  CAN_WRITE_USER = 'can_write_user',
  CAN_WRITE_WORKFLOWS = 'can_write_workflows'
}
